<template>
  <div class="wrap talk">
    <div class="container">
      <main class="content">
        <article class="certification atm">
          <section>
            <div class="con-box">
              <h2>ATM 정보<span>정기 유지보수 결과를 입력해주세요.</span></h2>
              <div class="form-wrap">
                <dl class="row row_jsb row_ac">
                  <dt>ATM 찾기</dt>
                  <dd class="width50">
                    <input
                      type="text"
                      class="t-input"
                      placeholder="COM 번호를 입력하세요"
                      v-model="mntcData.prchChnlAfliNum"
                    />
                  </dd>
                  <dd class="btn-wrap">
                    <a class="btn bg-default" @click="findAtmInfo">찾기</a>
                  </dd>
                </dl>
                <div class="info-inp">
                  <input
                    type="text"
                    class="t-input"
                    v-model="mntcData.atmInfo"
                    disabled
                  />
                </div>
                <dl class="row row_jsb row_ac">
                  <dt>외관</dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check">
                        <RadioCodeListType3
                          name="extlChckStatCd"
                          cmnsCdGrpId="ATM_MNTC_EXTL_CD"
                          @input="
                            value =>
                              handleExtlChckStatCd(value, 'extlChckStatCd')
                          "
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_wrap row_jsb row_ac">
                  <dt>촬영함</dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check">
                        <RadioCodeListType3
                          name="cmraExtlChckStatCd"
                          cmnsCdGrpId="ATM_MNTC_EXTL_CD"
                          @input="
                            value =>
                              handleExtlChckStatCd(value, 'cmraExtlChckStatCd')
                          "
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac mb_30">
                  <dt>케이블</dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check n5">
                        <label>
                          <input
                            type="checkbox"
                            v-model="mntcData.cablChckStatCd"
                            @change="onChangeCable"
                          />
                          <span>정상</span>
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            v-model="mntcData.cb5pChckStatCd"
                            @change="onChange5pCable"
                          />
                          <span>5핀</span>
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            v-model="mntcData.cb8pChckStatCd"
                            @change="onChange8pCable"
                          />
                          <span>8핀</span>
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            v-model="mntcData.cbctChckStatCd"
                            @change="onChangecCable"
                          />
                          <span>C-Type</span>
                        </label>
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>바코드용지</dt>
                  <dd>
                    <div class="label-check n6">
                      <label>
                        <input
                          type="radio"
                          value="1"
                          v-model="mntcData.brcdStatCd"
                        />
                        <span>교체</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="2"
                          v-model="mntcData.brcdStatCd"
                        />
                        <span>30%이상</span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="3"
                          v-model="mntcData.brcdStatCd"
                        />
                        <span>고장</span>
                      </label>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>특이사항</dt>
                  <dd>
                    <input
                      type="text"
                      class="t-input"
                      placeholder="특이사항 메모해주세요"
                      v-model="mntcData.spntCtts"
                    />
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>첨부 이미지</dt>
                  <dd class="t-input addfile">
                    <input
                      type="file"
                      placeholder=""
                      accept="image/*"
                      @change="onMntcFileChange"
                    />{{ mntcFileNm
                    }}<button type="button" class="btn-file">파일선택</button>
                  </dd>
                </dl>
              </div>
            </div>
          </section>
          <div class="btn-wrap" style="padding: 0.8125rem 0;">
            <a class="talk-btn btn-black" @click="mntcSave">유지보수저장</a>
          </div>
          <section v-if="false">
            <div class="con-box">
              <h2>ATM 이상신고<span>장애내용을 등록해주세요.</span></h2>
              <div class="form-wrap">
                <dl class="row row_jsb row_ac">
                  <dt>장애유형</dt>
                  <dd>
                    <select class="t-select" v-model="obstData.atmObstTypeCd">
                      <option value="">전체</option>
                      <option
                        v-for="atmObstType in atmObstTypeCds"
                        :key="atmObstType.code"
                        :value="atmObstType.cmnsCd"
                      >
                        {{ atmObstType.cmnsCdNm }}
                      </option>
                    </select>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>ATM상태</dt>
                  <dd>
                    <input
                      type="text"
                      class="t-input"
                      v-model="obstData.atmObstStatCd"
                      disabled
                    />
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>내용</dt>
                  <dd class="h-textarea">
                    <textarea
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      v-model="obstData.atmObstCtts"
                    ></textarea>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>첨부 이미지</dt>
                  <dd class="t-input addfile">
                    <input
                      type="file"
                      placeholder=""
                      accept="image/*"
                      @change="onObstFileChange"
                    />{{ obstFileNm
                    }}<button type="button" class="btn-file">파일선택</button>
                  </dd>
                </dl>
              </div>
            </div>
            <div class="btn-wrap">
              <a class="regist-btn btn-black" @click="obstSave">장애신고</a>
              <a class="regist-btn btn-black" @click="mntcObstSave"
                >유지보수/장애 일괄등록</a
              >
              <a class="list-btn btn-black" @click="gotoatmMntcHstr">리스트</a>
            </div>
          </section>
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import {
  DxColumn,
  DxDataGrid,
  DxScrolling,
  DxSelection,
  DxStringLengthRule
} from 'devextreme-vue/data-grid'

import Vue from 'vue'
import AppConfig from '@/config'
import DxDateBox from 'devextreme-vue/date-box'
import DxTextBox from 'devextreme-vue/text-box'
import DxTextArea from 'devextreme-vue/text-area'
import DxSelectBox from 'devextreme-vue/select-box'
import {mapGetters} from 'vuex'

import RadioCodeListType3 from '@/components/RadioCodeListType3.vue'

export default {
  name: 'AtmMntcSchdUpdate',
  components: {
    DxColumn,
    DxTextBox,
    DxDateBox,
    DxTextArea,
    DxDataGrid,
    DxScrolling,
    DxSelection,
    DxSelectBox,
    DxStringLengthRule,
    RadioCodeListType3
  },
  data () {
    return {
      prefixUrl: '/api/purchase/customerCare/atmMntcSchdUpdate',
      mntcData: {
        prchChnlAfliNum: '',
        atmInfo: '',
        atmNum: '',
        atmId: '',
        atmDvsnCd: '',
        extlChckStatCd: '',
        cmraExtlChckStatCd: '',
        atmMntcSchdNum: '',
        workYymm: '',
        workDt: '',
        cablChckStatCd: false,
        cb5pChckStatCd: false,
        cb8pChckStatCd: false,
        cbctChckStatCd: false,
        apndFlInfo: ''
      },
      obstData: {
        atmNum: '',
        atmStatCd: '',
        atmObstTypeCd: '',
        atmObstStatCd: '',
        atmObstRegCd: '',
        atmObstCtts: '',
        apndFlInfo: '',
        wrkwDvsnCd: ''
      },
      atmObstTypeCds: [],
      mntcFile: null,
      obstFile: null,
      mntcFileNm: '',
      obstFileNm: ''
    }
  },
  computed: {
    ...mapGetters('Login', {
      userId: 'getUserId',
      roleLevel: 'getRoleLevel'
    }),
    ...mapGetters('LatestMenu', {
      latestMenuList: 'getLatestMenuList',
      current: 'getCurrent'
    })
  },
  watch: {
    '$route' (to, from) {
      // 초기화 작업
      if (to.name === 'AtmMntcSchdUpdate') {
        this.init()
      }
    }
  },
  methods: {
    handleExtlChckStatCd (value, trgtDataName) {
      Object.assign(this.mntcData, { [trgtDataName]: value })
    },
    onMntcFileChange (e) {
      this.mntcFile = e.target.files[0] || e.dataTransfer.files[0]
      this.mntcFileNm = this.mntcFile.name
    },
    onObstFileChange (e) {
      this.obstFile = e.target.files[0] || e.dataTransfer.files[0]
      this.obstFileNm = this.obstFile.name
    },
    onChangeCable (e) {
      if (this.mntcData.cablChckStatCd === true) {
        // 정상이면 다른 것은 해제
        this.mntcData.cb5pChckStatCd = false
        this.mntcData.cb8pChckStatCd = false
        this.mntcData.cbctChckStatCd = false
      }
    },
    onChange5pCable (e) {
      if (this.mntcData.cb5pChckStatCd === true) {
        // 5핀 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    onChange8pCable (e) {
      if (this.mntcData.cb8pChckStatCd === true) {
        // 8핀 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    onChangecCable (e) {
      if (this.mntcData.cbctChckStatCd === true) {
        // C-type 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    waitForNextAction (timeToDelay) {
      return new Promise((resolve) => setTimeout(resolve, timeToDelay))
    },
    async findAtmInfo () {
      if (!this.mntcData.prchChnlAfliNum) {
        window.$Alert.alert('COM 번호를 입력하세요~')
        return
      }
      // 기존의 있는 값이 있지 않게 하기 위한 작업
      this.mntcData.atmNum = ''
      this.obstData.atmNum = ''

      await Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrBsncnum', {params: { ...this.mntcData }})
        .then((response) => {
          if (response && response.data && response.data.result) {
            const prchChnlAfliObj = response.data.result
            if (!prchChnlAfliObj) {
              this.mntcData = {...this.mntcData, atmNum: '', atmId: '', atmInfo: '', atmDvsnCd: ''}
              this.obstData.atmNum = ''
              window.$Alert.alert('COM 번호를 확인해 주세요!')
              return
            } else {
              this.mntcData = {...this.mntcData, atmNum: prchChnlAfliObj.atmNum, atmId: prchChnlAfliObj.atmId, atmInfo: prchChnlAfliObj.atmInfo, atmDvsnCd: prchChnlAfliObj.atmDvsnCd}
              this.obstData.atmNum = prchChnlAfliObj.atmNum
            }
          } else {
            this.mntcData = {...this.mntcData, atmNum: '', atmId: '', atmInfo: '', atmDvsnCd: ''}
            this.obstData.atmNum = ''
            window.$Alert.alert('COM 번호를 확인해 주세요!')
          }
        })

      if (this.mntcData.atmNum == null || this.mntcData.atmNum === '') {
        this.mntcData = {...this.mntcData, atmId: '', atmInfo: '', atmDvsnCd: ''}
        this.obstData = {...this.obstData, atmNum: '', atmObstStatCd: ''}
        window.$Alert.alert('COM 번호를 확인해 주세요!')
      } else {
        this.findAtmNumStat()
      }
    },
    async findAtmNumStat () {
      // ATM의 장애상태값 초기화 작업
      this.obstData.atmObstStatCd = ''
      this.obstData.atmNum = this.mntcData.atmNum
      // ATM의 상태값 조회
      await Vue.httpClient.get('/api/purchase/customerCare/selectAtmNumStatCheck', {params: { ...this.obstData }})
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            const { atmObstStatCd, atmStatCd } = response.data.result[0]
            this.obstData = { ...this.obstData, atmObstStatCd, atmStatCd }
          }
        })
      // 구분자 값으로 민팃박스로 확인하여 저장하지 못하게 - 2021-12-06 요청사항임
      if (this.mntcData.atmDvsnCd === 5) {
        this.atmMntcButton = false
        window.$Alert.alert('민팃박스는 등록 할 수 없습니다.')
      } else {
        this.atmMntcButton = true
      }
    },
    async upload (uploadFile) {
      const fd = new FormData()
      fd.append('files', uploadFile)
      const { data } = await Vue.httpClient.post('/api/purchase/customerCare/imageUpload',
        fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (data.status === '200') {
        return data.result
      } else {
        return ''
      }
    },
    mntcVaildationCheck () {
      if (this.mntcData.atmNum == null || this.mntcData.atmNum === '' || this.mntcData.prchChnlAfliNum == null || this.mntcData.prchChnlAfliNum === '') {
        window.$Alert.alert('COM 번호를 확인해 주세요.')
        return false
      }
      if (!this.mntcData.extlChckStatCd) {
        window.$Alert.alert('외관을 선택하세요.')
        return false
      }
      if (!this.mntcData.cmraExtlChckStatCd) {
        window.$Alert.alert('촬영함을 선택하세요.')
        return false
      }
      if ((this.mntcData.cablChckStatCd == null || this.mntcData.cablChckStatCd === false) &&
          (this.mntcData.cb5pChckStatCd == null || this.mntcData.cb5pChckStatCd === false) &&
          (this.mntcData.cb8pChckStatCd == null || this.mntcData.cb8pChckStatCd === false) &&
          (this.mntcData.cbctChckStatCd == null || this.mntcData.cbctChckStatCd === false)) {
        window.$Alert.alert('케이블을 선택하세요.')
        return false
      }
      if (this.mntcData.brcdStatCd == null || this.mntcData.brcdStatCd === false) {
        window.$Alert.alert('바코드를 선택하세요.')
        return false
      }
      if (this.mntcData.spntCtts && this.mntcData.spntCtts.length > 200) {
        window.$Alert.alert('특이사항은 최대 200자 입니다.')
        return false
      }
      return true
    },
    async mntcSave () {
      if (!this.mntcVaildationCheck()) return

      const confirm = await this.$Alert.confirm('저장 하시겠습니까?')
      if (!confirm) return

      if (this.mntcFile) {
        this.mntcData.apndFlInfo = await this.upload(this.mntcFile)
      }

      Vue.httpClient.post('/api/purchase/customerCare/atmMntcSchdUpdate', { ...this.mntcData }).then((response) => {
        if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
          Vue.httpClient.post('/api/purchase/customerCare/atmMntcHstrInsert', { ...this.mntcData }).then((response) => {
            if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
              this.gotoatmMntcHstr()
            }
          })
        }
      })
    },
    obstVaildationCheck () {
      if (!this.obstData.atmNum) {
        window.$Alert.alert('COM 번호를 확인해 주세요.')
        return false
      }

      if (this.obstData.atmStatCd !== '1') {
        window.$Alert.alert('장애신고는 ATM상태가 정상이면 가능합니다.')
        return false
      }

      if (!this.obstData.atmObstTypeCd) {
        window.$Alert.alert('장애유형을 선택하세요.')
        return false
      }
      if (!this.obstData.atmObstCtts) {
        window.$Alert.alert('장애내용을 입력하세요.')
        return false
      }
      return true
    },
    async obstSave () {
      if (!this.obstVaildationCheck()) return

      const confirm = await this.$Alert.confirm('저장 하시겠습니까?')
      if (!confirm) return

      if (this.obstFile) {
        this.obstData.apndFlInfo = await this.upload(this.obstFile)
      }

      this.obstData.wrkwDvsnCd = '10'

      Vue.httpClient.post('/api/purchase/customerCare/atmObstHstrInsert', {...this.obstData})
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.$router.push({name: 'AtmObstHstr', params: { }})
          }
        })
    },
    async mntcObstSave () {
      if (!this.mntcVaildationCheck()) return
      if (!this.obstVaildationCheck()) return

      if (this.mntcFile) {
        this.mntcData.apndFlInfo = await this.upload(this.mntcFile)
      }
      await Vue.httpClient.post('/api/purchase/customerCare/atmMntcHstrInsert', { ...this.mntcData }).then((response) => {
        if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
          Vue.httpClient.post('/api/purchase/customerCare/atmObstHstrInsert', {...this.obstData})
            .then((response) => {
              if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
                this.gotoatmMntcHstr()
              }
            })
        }
      })
    },
    gotoatmMntcHstr () {
      // this.$router.push({name: 'AtmMntcSchd', params: { }})
      this.$router.go(-1)
    },
    // 아래의 async를 넣지 않으면 에러발생 - 사용하는 장애유형 조회하기
    async setCommCodeByAtmObstTypeCds () {
      const params = {}
      const response = await Vue.httpClient.post('/api/purchase/customerCare/atmObstTypeMngtUseList', params)
      const codeList = []

      if (response && response.data && response.data.result) {
        response.data.result.forEach(c => {
          codeList.push({
            cmnsCd: c.atmObstTypeCd,
            cmnsCdNm: c.atmObstTypeNm,
            guidCtts: c.guidCtts
          })
        })
      }
      this.atmObstTypeCds = [...codeList]
      this.obstData.atmObstTypeCd = ''
    },
    async atmMntcHstrList (atmMntcHstrNum) {
      const { data } = await Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrList', {params: { ...this.mntcData, atmMntcHstrNum }})
      this.mntcData = data.result.list[0]
    },
    async init () {
      this.mntcData = {
        prchChnlAfliNum: '',
        atmInfo: '',
        atmNum: '',
        atmDvsnCd: '',
        extlChckStatCd: '',
        cmraExtlChckStatCd: '',
        atmMntcSchdNum: '',
        workYymm: '',
        workDt: '',
        cablChckStatCd: false,
        cb5pChckStatCd: false,
        cb8pChckStatCd: false,
        cbctChckStatCd: false,
        apndFlInfo: ''
      }
      this.obstData = {
        atmNum: '',
        atmStatCd: '',
        atmObstTypeCd: '',
        atmObstStatCd: '',
        atmObstCtts: '',
        apndFlInfo: ''
      }

      this.mntcFile = null
      this.obstFile = null
      this.mntcFileNm = ''
      this.obstFileNm = ''

      // 장애유형 조회하기
      await this.setCommCodeByAtmObstTypeCds()

      this.mntcData = {
        ...this.mntcData,
        atmMntcSchdNum: this.$route.params.data.atmMntcSchdNum,
        prchChnlAfliNum: this.$route.params.data.prchChnlAfliNum
      }

      if (this.$route.params.data.workDt != null) {
        this.mntcData.workDt = this.$route.params.data.workDt
      }

      this.findAtmInfo()
    }
  },
  async mounted () {
    // 초기화 작업
    this.init()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmMntcSchdUpdate.vue